module.exports = __webpack_public_path__ + "img/bespoke70_21.cf6eec07.jpg";